export const CRM_MEETING_PREP_MVP_FLAG_KEY = 'crm_meetingprep_mvp'
